import { CommandList } from '@ttab/elephant-ui'
import { ClearFilter } from '@/components/Filter/ClearFilter'
import { ColumnFilter } from './Items'
import { useTable } from '@/hooks/useTable'
import type { JSX } from 'react'
import { FreeTextFilter } from '../Filter/common/FreeTextFilter'

export const Commands = ({ filterType }: { filterType?: 'freetext' | 'filterOptions' }): JSX.Element => {
  const { table, command } = useTable()
  const { setSearch, search } = command

  const state = table.getState()
  const globalFilter = typeof state.globalFilter === 'string' ? state.globalFilter : ''
  const hasFilter = !!state.columnFilters.length || typeof state.globalFilter === 'string'

  const handleClear = () => {
    table.resetColumnFilters()
    table.resetGlobalFilter()
  }

  const handleFreetextChange = (value: string) => {
    if (value) {
      table.setGlobalFilter(value)
    } else {
      table.resetGlobalFilter()
    }
  }

  return (
    <>
      {filterType !== 'freetext' && (
        <FreeTextFilter filterType='filterOptions' value={search ?? ''} onChange={setSearch} />
      )}
      <CommandList>
        {filterType === 'freetext' && (
          <FreeTextFilter filterType='freetext' value={globalFilter} onChange={handleFreetextChange} />
        )}
        <ColumnFilter />
        <ClearFilter hasFilter={hasFilter} onClear={handleClear} />
      </CommandList>
    </>
  )
}
